export interface TopAirline {
    id: string
    name: string
    logo?: string
}

export interface TopAirlinesData {
    title: string
    airlines: {
        name_en: string
        name_ar: string
        href_en: string
        href_ar: string
    }[]
}

export const TOP_AIRLINES_FLYIN: TopAirline[] = [
    { id: 'sv', name: 'Saudi Arabian Airlines' },
    { id: 'f3', name: 'Flyadeal' },
    { id: 'ku', name: 'Kuwait Airways' },
    { id: 'g9', name: 'Air Arabia' },
    { id: '9w', name: 'Jet Airways' },
    { id: 'gf', name: 'Gulf Air' },
    { id: 'et', name: 'Ethiopian Airlines' },
    { id: 'ms', name: 'Air Cairo' },
    { id: 'me', name: 'Middle East Airlines' },
    { id: 'b8', name: 'Eritrean Airlines' },
    { id: 'xy', name: 'Flynas' },
    { id: 'np', name: 'Nile Air' },
    { id: 'fz', name: 'Flydubai Airways' },
    { id: 'ul', name: 'SriLankan Airlines' },
    { id: 'pr', name: 'Philippine Airlines' },
    { id: 'wy', name: 'Oman Air' },
    { id: 'ey', name: 'Etihad Airways' },
    { id: 'sq', name: 'Singapore Airlines' },
    { id: 'pg', name: 'Bangkok Airways' },
    { id: 'ov', name: 'Salam Air' },
    { id: 'ne', name: 'Nesma Airlines' },
    { id: 'ms', name: 'Egypt Air' },
    { id: 'tk', name: 'Turkish Airlines' },
    { id: 'ba', name: 'British Airways' },
    { id: 'lh', name: 'Lufthansa' },
    { id: 'rj', name: 'Royal Jordanian' },
    { id: 'af', name: 'Air France' },
    { id: 'at', name: 'Royal Air Maroc' },
    { id: '5j', name: 'Cebu Pacific Air' },
    { id: 'vy', name: 'Vueling airlines' },
    { id: 'SG', name: 'SpiceJet' },
    { id: 'UK', name: 'Vistara Airlines' },
    { id: 'KQ', name: 'Kenya Airways' },
    { id: 'KL', name: 'KLM Royal Dutch Airlines' },
    { id: 'J9', name: 'Jazeera Airways' },
    { id: 'ER', name: 'Serene Air' },
    { id: 'PA', name: 'Airblue' }
]


export const TOP_AIRLINES_CLEARTRIP = [
    { id: 'SG', name: 'Spicejet' },
    { id: 'XY', name: 'FlyNas' },
    { id: 'PR', name: 'Philippine Airlines' },
    { id: '5J', name: 'Cebu Pacific' },
    { id: 'SV', name: 'Saudi Arabian Airlines' },
    { id: 'UK', name: 'Vistara Airlines' },
    { id: 'UL', name: 'SriLankan Airlines' },
    { id: 'GF', name: 'Gulf Air' },
    { id: 'MS', name: 'Egyptair Airlines' },
    { id: 'TK', name: 'Turkish Airlines' },
    { id: 'ME', name: 'Middle East Airlines' },
    { id: 'SQ', name: 'Singapore Airlines' },
    { id: 'KQ', name: 'Kenya Airways' },
    { id: 'RJ', name: 'Royal Jordanian Airlines' },
    { id: 'KL', name: 'KLM Royal Dutch Airlines' },
    { id: 'ET', name: 'Ethiopian Air' },
    { id: 'J9', name: 'Jazeera Airways' },
    { id: 'ER', name: 'Serene Air' },
    { id: 'AF', name: 'Air France' },
    { id: 'PA', name: 'Airblue' },
    { id: 'BA', name: 'British Airways' }
]

export const flyinCommonTopAirlines = {
    title: 'Top Airlines',
    airlines: [
        {
            name_en: 'Saudi Arabian Airlines',
            name_ar: 'الخطوط الجوية السعودية',
            href_en: '/en/airlines/Saudi-Arabian-Airlines.en.html',
            href_ar: '/ar/airlines/Saudi-Arabian-Airlines.ar.html'
        },
        {
            name_en: 'Flynas',
            name_ar: 'طيران ناس',
            href_en: '/en/airlines/FLYNAS.en.html',
            href_ar: '/ar/airlines/FLYNAS.ar.html'
        },
        {
            name_en: 'Nesma Airlines',
            name_ar: 'طيران نسما',
            href_en: '/en/airlines/Nesma-Airlines.en.html',
            href_ar: '/ar/airlines/Nesma-Airlines.ar.html'
        },
        {
            name_en: 'Flyadeal',
            name_ar: 'طيران أديل',
            href_en: '/en/airlines/Flyadeal-Airlines.en.html',
            href_ar: '/ar/airlines/Flyadeal-Airlines.ar.html'
        },
        {
            name_en: 'Nile Air',
            name_ar: 'طيران النيل',
            href_en: '/en/airlines/NILE-AIR-.en.html',
            href_ar: '/ar/airlines/NILE-AIR-.ar.html'
        },
        {
            name_en: 'Egypt Air',
            name_ar: 'مصر للطيران',
            href_en: '/en/airlines/Egypt-Air.en.html',
            href_ar: '/ar/airlines/Egypt-Air.ar.html'
        },
        {
            name_en: 'Kuwait Airways',
            name_ar: 'الخطوط الجوية الكويتية',
            href_en: '/en/airlines/KUWAIT-AIRWAYS-.en.html',
            href_ar: '/ar/airlines/KUWAIT-AIRWAYS-.ar.html'
        },
        {
            name_en: 'Turkish Airlines',
            name_ar: 'الخطوط الجوية التركية',
            href_en: '/en/airlines/Turkish-Airlines.en.html',
            href_ar: '/ar/airlines/Turkish-Airlines.ar.html'
        },
        {
            name_en: 'Flydubai Airways',
            name_ar: 'فلاي دبي',
            href_en: '/en/airlines/Fly-Dubai-.en.html',
            href_ar: '/ar/airlines/Fly-Dubai-.ar.html'
        },
        {
            name_en: 'Air Arabia',
            name_ar: 'العربية للطيران',
            href_en: '/en/airlines/Air-Arabia.en.html',
            href_ar: '/ar/airlines/Air-Arabia.ar.html'
        },
        {
            name_en: 'SriLankan Airlines',
            name_ar: 'الخطوط الجوية السريلانكية',
            href_en: '/en/airlines/Srilankan-Airlines.en.html',
            href_ar: '/ar/airlines/Srilankan-Airlines.ar.html'
        },
        {
            name_en: 'Air India',
            name_ar: 'الخطوط الجوية الهندية',
            href_en: '/en/airlines/air-india.en.html',
            href_ar: '/ar/airlines/air-india.ar.html'
        },
        {
            name_en: 'British Airways',
            name_ar: 'الخطوط الجوية البريطانية',
            href_en: '/en/airlines/British-Airways.en.html',
            href_ar: '/ar/airlines/British-Airways.ar.html'
        },
        {
            name_en: 'Jet Airways',
            name_ar: 'جيت إيروايز',
            href_en: '/en/airlines/Jet-Airways.en.html',
            href_ar: '/ar/airlines/Jet-Airways.ar.html'
        },
        {
            name_en: 'Philippine Airlines',
            name_ar: 'الخطوط الجوية الفلبينية',
            href_en: '/en/airlines/Philippine-Airlines.en.html',
            href_ar: '/ar/airlines/Philippine-Airlines.ar.html'
        },
        {
            name_en: 'Lufthansa',
            name_ar: 'لوفتهانزا',
            href_en: '/en/airlines/Lufthansa.en.html',
            href_ar: '/ar/airlines/Lufthansa.ar.html'
        },
        {
            name_en: 'Gulf Air',
            name_ar: 'طيران الخليج',
            href_en: '/en/airlines/Gulf-Air.en.html',
            href_ar: '/ar/airlines/Gulf-Air.ar.html'
        },
        {
            name_en: 'Oman Air',
            name_ar: 'الطيران العماني',
            href_en: '/en/airlines/Oman-Air.en.html',
            href_ar: '/ar/airlines/Oman-Air.ar.html'
        },
        {
            name_en: 'Ethiopian Airlines',
            name_ar: 'الخطوط الجوية الإثيوبية',
            href_en: '/en/airlines/ethiopian-airlines.en.html',
            href_ar: '/ar/airlines/ethiopian-airlines.ar.html'
        },
        {
            name_en: 'Royal Jordanian',
            name_ar: 'الملكية الأردنية',
            href_en: '/en/airlines/Royal-Jordanian.en.html',
            href_ar: '/ar/airlines/Royal-Jordanian.ar.html'
        },
        {
            name_en: 'Etihad Airways',
            name_ar: 'طيران الاتحاد',
            href_en: '/en/airlines/Etihad-Airways.en.html',
            href_ar: '/ar/airlines/Etihad-Airways.ar.html'
        },
        {
            name_en: 'Air France',
            name_ar: 'الخطوط الجوية الفرنسية',
            href_en: '/en/airlines/Air-France.en.html',
            href_ar: '/ar/airlines/Air-France.ar.html'
        },
        {
            name_en: 'Air Cairo',
            name_ar: 'إير كايرو',
            href_en: '/en/airlines/Air-Cairo.en.html',
            href_ar: '/ar/airlines/Air-Cairo.ar.html'
        },
        {
            name_en: 'Singapore Airlines',
            name_ar: 'الخطوط الجوية السنغافورية',
            href_en: '/en/airlines/singapore-airlines.en.html',
            href_ar: '/ar/airlines/singapore-airlines.ar.html'
        },
        {
            name_en: 'Qatar Airways',
            name_ar: 'الخطوط الجوية القطرية',
            href_en: '/en/airlines/Qatar-Airways.en.html',
            href_ar: '/ar/airlines/Qatar-Airways.ar.html'
        },
        {
            name_en: 'Royal Air Maroc',
            name_ar: 'الخطوط الملكية المغربية',
            href_en: '/en/airlines/ROYAL-AIR-MAROC.en.html',
            href_ar: '/ar/airlines/ROYAL-AIR-MAROC.ar.html'
        },
        {
            name_en: 'Middle East Airlines',
            name_ar: 'طيران الشرق الأوسط',
            href_en: '/en/airlines/Middle-East-Airlines.en.html',
            href_ar: '/ar/airlines/Middle-East-Airlines.ar.html'
        },
        {
            name_en: 'Bangkok Airways',
            name_ar: 'بانكوك إيروايز',
            href_en: '/en/airlines/bangkok-airways.en.html',
            href_ar: '/ar/airlines/bangkok-airways.ar.html'
        },
        {
            name_en: 'Cebu Pacific Air',
            name_ar: 'سيبو باسيفيك للطيران',
            href_en: '/en/airlines/cebu-pacific-air.en.html',
            href_ar: '/ar/airlines/cebu-pacific-air.ar.html'
        },
        {
            name_en: 'Eritrean Airlines',
            name_ar: 'الخطوط الجوية الإريترية',
            href_en: '/en/airlines/eritrean-airlines.en.html',
            href_ar: '/ar/airlines/eritrean-airlines.ar.html'
        }
    ]
}

export const cleartripCommonTopAirlines = {
    title: 'Top Airlines',
    airlines: [
        {
            name_en: 'Spicejet',
            name_ar: 'سبايس جيت',
            href_en: '/flight-booking/spicejet-airlines.html',
            href_ar: '/ar/flight-booking/spicejet-airlines.html'
        },
        {
            name_en: 'FlyNas',
            name_ar: 'طيران ناس',
            href_en: '/flight-booking/flynas-airlines.html',
            href_ar: '/ar/flight-booking/flynas-airlines.html'
        },
        {
            name_en: 'Philippine Airlines',
            name_ar: 'الخطوط الجوية الفلبينية',
            href_en: '/flight-booking/philippine-airlines.html',
            href_ar: '/ar/flight-booking/philippine-airlines.html'
        },
        {
            name_en: 'Cebu Pacific',
            name_ar: 'سيبو باسيفيك',
            href_en: '/flight-booking/cebu-pacific-air-airlines.html',
            href_ar: '/ar/flight-booking/cebu-pacific-air-airlines.html'
        },
        {
            name_en: 'Saudi Arabian Airlines',
            name_ar: 'الخطوط الجوية السعودية',
            href_en: '/flight-booking/saudi-arabian-air-airlines.html',
            href_ar: '/ar/flight-booking/saudi-arabian-air-airlines.html'
        },
        {
            name_en: 'Vistara Airlines',
            name_ar: 'فيستارا',
            href_en: '/flight-booking/vistara-airlines.html',
            href_ar: '/ar/flight-booking/vistara-airlines.html'
        },
        {
            name_en: 'SriLankan Airlines',
            name_ar: 'الخطوط الجوية السريلانكية',
            href_en: '/flight-booking/srilankan-airlines.html',
            href_ar: '/ar/flight-booking/srilankan-airlines.html'
        },
        {
            name_en: 'Gulf Air',
            name_ar: 'طيران الخليج',
            href_en: '/flight-booking/gulf-air-airlines.html',
            href_ar: '/ar/flight-booking/gulf-air-airlines.html'
        },
        {
            name_en: 'Egyptair Airlines',
            name_ar: 'مصر للطيران',
            href_en: '/flight-booking/egyptair-airlines.html',
            href_ar: '/ar/flight-booking/egyptair-airlines.html'
        },
        {
            name_en: 'Turkish Airlines',
            name_ar: 'الخطوط الجوية التركية',
            href_en: '/flight-booking/turkish-airlines.html',
            href_ar: '/ar/flight-booking/turkish-airlines.html'
        },
        {
            name_en: 'Middle East Airlines',
            name_ar: 'طيران الشرق الأوسط',
            href_en: '/flight-booking/middle-east-airlines.html',
            href_ar: '/ar/flight-booking/middle-east-airlines.html'
        },
        {
            name_en: 'Singapore Airlines',
            name_ar: 'الخطوط الجوية السنغافورية',
            href_en: '/flight-booking/singapore-airlines.html',
            href_ar: '/ar/flight-booking/singapore-airlines.html'
        },
        {
            name_en: 'Kenya Airways',
            name_ar: 'الخطوط الجوية الكينية',
            href_en: '/flight-booking/kenya-airways-airlines.html',
            href_ar: '/ar/flight-booking/kenya-airways-airlines.html'
        },
        {
            name_en: 'Royal Jordanian Airlines',
            name_ar: 'الملكية الأردنية',
            href_en: '/flight-booking/royal-jordanian-airlines.html',
            href_ar: '/ar/flight-booking/royal-jordanian-airlines.html'
        },
        {
            name_en: 'KLM Royal Dutch Airlines',
            name_ar: 'الخطوط الجوية الملكية الهولندية',
            href_en: '/flight-booking/klm-royal-dutch-airlines.html',
            href_ar: '/ar/flight-booking/klm-royal-dutch-airlines.html'
        },
        {
            name_en: 'Ethiopian Air',
            name_ar: 'الخطوط الجوية الإثيوبية',
            href_en: '/flight-booking/ethiopian-air-airlines.html',
            href_ar: '/ar/flight-booking/ethiopian-air-airlines.html'
        },
        {
            name_en: 'Jazeera Airways',
            name_ar: 'طيران الجزيرة',
            href_en: '/flight-booking/jazeera-airways-airlines.html',
            href_ar: '/ar/flight-booking/jazeera-airways-airlines.html'
        },
        {
            name_en: 'Serene Air',
            name_ar: 'طيران سيرين',
            href_en: '/flight-booking/serene-air-airlines.html',
            href_ar: '/ar/flight-booking/serene-air-airlines.html'
        },
        {
            name_en: 'Air France',
            name_ar: 'الخطوط الجوية الفرنسية',
            href_en: '/flight-booking/air-france-airlines.html',
            href_ar: '/ar/flight-booking/air-france-airlines.html'
        },
        {
            name_en: 'Airblue',
            name_ar: 'إير بلو',
            href_en: '/flight-booking/airblue-airlines.html',
            href_ar: '/ar/flight-booking/airblue-airlines.html'
        },
        {
            name_en: 'British Airways',
            name_ar: 'الخطوط الجوية البريطانية',
            href_en: '/flight-booking/british-airways-airlines.html',
            href_ar: '/ar/flight-booking/british-airways-airlines.html'
        }
    ]
}

export const TOP_AIRLINES = {
    flyin: TOP_AIRLINES_FLYIN,
    cleartrip: TOP_AIRLINES_CLEARTRIP
}

export const TopAirlinesByDomain: Record<string, TopAirlinesData> = {
    AE: cleartripCommonTopAirlines,
    SA: cleartripCommonTopAirlines,
    KW: cleartripCommonTopAirlines,
    BH: cleartripCommonTopAirlines,
    OM: cleartripCommonTopAirlines,
    QA: cleartripCommonTopAirlines,
    FSA: flyinCommonTopAirlines,
    FEG: flyinCommonTopAirlines,
    FAE: flyinCommonTopAirlines
}


export default { TopAirlinesByDomain,  TOP_AIRLINES_CLEARTRIP, TOP_AIRLINES_FLYIN }